module.exports = __webpack_public_path__ + "static/media/Boxer.27589952.jpg";